import BaseService from "@/services/BaseService";
import { config, CONFIG } from "@/config";
import {CreditScore, FraudScore} from "@/lib/types/score/finsey";
import BubbleService from "@/services/Bubble/BubbleService";

class FinseyScoreService extends BaseService{

    constructor() {
        super(config.finseyScore.endpoint,{
            'Authorization' : config.finseyScore.token
        });
    }

    getFraudScore = async (application_id: string, cccd: string, mobile: string):Promise<FraudScore> => {
        const bubbleService = new BubbleService()
        let params = `?id=${cccd}&mobile=${mobile}`
        let data:any = await this.get('/user-profile/scoring/fraud/general' + params)
        console.log({score:data})
        let scoreData:FraudScore = {
            score: data.score,
            data: JSON.stringify(data),
            level: this.getFraudScoreLevel(data.score)
        }
        const bubbleScore = await bubbleService.postWf('update_finsey_fraud_score',{
            application_id,
            ...scoreData
        })
        console.log({bubbleScore})
        return scoreData
    }

    getCreditScore = async (application_id: string, cccd: string, mobile: string):Promise<CreditScore> => {
        const bubbleService = new BubbleService()
        let params = `?id=${cccd}&mobile=${mobile}`
        let data:any = await this.get('/user-profile/scoring/get' + params)
        console.log({score:data})
        let scoreData:FraudScore = {
            score: data.score,
            data: JSON.stringify(data),
            level: this.getFraudScoreLevel(data.score)
        }
        const bubbleScore = await bubbleService.postWf('update_finsey_credit_score',{
            application_id,
            ...scoreData
        })
        console.log({bubbleScore})
        return scoreData
    }

    fetchCreditScore = async (cccd: string, mobile: string):Promise<any> => {
        let params = `?id=${cccd}&mobile=${mobile}`
        let data:any = await this.get('/user-profile/scoring/get' + params)
        console.log({score:data})
        return data
    }

    getFraudScoreLevel = (score: number) => {
        score = score * 10;
        if(score < 4){
            return 'low'
        }else if(score < 7){
            return 'medium'
        }else{
            return 'high'
        }
    }

    getCreditScoreLevel = (score: number) => {
        score = score * 10;
        if(score < 4){
            return 'low'
        }else if(score < 7){
            return 'medium'
        }else{
            return 'high'
        }
    }

    getFraudScorePercent = (score: number) => {
        return Math.ceil(score * 100)
    }

    getCreditScorePercent = (score: number) => {
        return Math.ceil(score * 100)
    }
}

export default FinseyScoreService